import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, CheckboxModule, RadiobuttonModule } from '@lib/components';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StaticMsgModule, StaticMsgPipe } from '@lib/pipes';
import { AswMasterStoreModule } from '@lib/store';
import { CommonLibModule } from '@lib/services';
import { LanguageSelectionModalComponent } from './language-selection-modal.component';

@NgModule({
  declarations: [LanguageSelectionModalComponent],
  providers: [StaticMsgPipe],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CheckboxModule,
    RadiobuttonModule,
    ButtonModule,
    TranslateModule,
    StaticMsgModule,
    CommonLibModule,
    AswMasterStoreModule,
  ],
  exports: [LanguageSelectionModalComponent],
})
export class LanguageSelectionModalModule {}
